import React, { useEffect } from 'react';

const ReceiptUserAgentEmail = ({
    setEmailAddr,
    verifiedEmail,
    doNextClick,
    showEmailField,
    emailAddr,
    EmailValidation,
    checked,
    setChecked,
    handleEmailChange,
    setShowEmailField,
}) => {

    useEffect(() => {
        if (!emailAddr && verifiedEmail) {
            setEmailAddr(verifiedEmail);
        }

    }, [verifiedEmail]);

    return (
        <div className="input-container p-5 translate-dynamic">
            {verifiedEmail
                ?   <>
                        <p>We’ll send a copy of the receipt to <span className="text-bold break-words-on-wrap">{verifiedEmail}</span>.</p>
                        <p className="text-underline mx-1 cursor" onClick={() => setShowEmailField(!showEmailField)}>Not your email address?</p>
                    </>
                : <p className="mx-1" onClick={() => setShowEmailField(!showEmailField)}>Enter your email to receive a copy of the customer’s carbon offset receipt.</p>
            }

            {showEmailField && <>
                <form onSubmit={doNextClick} className="m-1 email-form">
                    <div className="form-content">
                        <div className="input-wrapper text-left m-1 pr-2">
                            <input value={emailAddr} type='email' onChange={handleEmailChange} className="form-input" />
                        </div>

                        <button onClick={(e) => doNextClick(e)} className="no-color-btn btn-secondary" type="button">
                            Save
                        </button>
                    </div>
                    {EmailValidation}

                    <label className="d-flex v-center mt-3" style={{ fontSize: 'inherit !important' }}>
                        <input type="checkbox" checked={checked} onChange={() => setChecked(!checked)} />
                        <span className="pl-2 mobile-p-0">Keep me informed about Climate Friendly Travel.</span>
                    </label>
                </form>
            </>
            }
        </div>
    )
}

export default ReceiptUserAgentEmail;
